export default function() {
  // We write code to connect the Bootstrap button group with checkbox
  // behavior to the backbone model

  Backbone.Stickit.addHandler([
    {
      selector: '.js-stickit-btn-group-checkbox',
      events: ['click'],
      update($el, val) {
        if (typeof val === 'string') {
          val = val === 'true';
        }

        if (val) {
          $el.removeClass('active').addClass('active');
        } else {
          $el.removeClass('active');
        }
      },
      getVal($el, event, options) {
        // Since this is a checkbox, the new value is the opposite
        // of the current model value
        return !this.model.get(options.observe);
      },
    },
  ]);
}



// WEBPACK FOOTER //
// ./js/backbone/utilities/add_btn_group_checkbox_stickit.js